import { motion } from 'framer-motion';
import type { EnemyInstance } from '@/engine/combat';
import { cn } from '@/utils/cn';

const PALETA: Record<EnemyInstance['paleta'], { bg: string; accent: string }> = {
  humano: { bg: 'bg-ash-800', accent: 'bg-ember-700' },
  sombra: { bg: 'bg-mystic-950', accent: 'bg-ash-700' },
  fuego: { bg: 'bg-ember-900', accent: 'bg-ember-500' },
  bestia: { bg: 'bg-moss-900', accent: 'bg-moss-600' },
};

export function EnemyPortrait({ enemy, shake }: { enemy: EnemyInstance; shake?: boolean }) {
  const p = PALETA[enemy.paleta];
  const hpPct = (enemy.vidaActual / enemy.vida) * 100;

  return (
    <motion.div
      animate={shake ? { x: [0, -4, 4, -2, 2, 0] } : undefined}
      transition={{ duration: 0.35 }}
      className="relative w-full max-w-xs mx-auto"
    >
      <div
        className={cn(
          'aspect-[3/4] rounded-md flex items-center justify-center relative overflow-hidden',
          p.bg,
        )}
      >
        {/* Silueta placeholder */}
        <div
          className={cn(
            'w-32 h-44 rounded-full blur-2xl opacity-70 absolute',
            p.accent,
          )}
        />
        <span className="relative font-display text-4xl text-ash-100/40">?</span>
      </div>
      <div className="mt-3">
        <div className="flex justify-between items-baseline">
          <h3 className="font-display text-lg text-ash-100">{enemy.nombre}</h3>
          <span className="text-xs font-ui text-ash-500 tabular-nums">
            {enemy.vidaActual}/{enemy.vida}
          </span>
        </div>
        <div className="mt-2 h-2 bg-ash-900 rounded overflow-hidden">
          <motion.div
            className="h-full bg-ember-600"
            animate={{ width: `${hpPct}%` }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
          />
        </div>
        <p className="text-xs italic text-ash-500 mt-1">{enemy.descripcionCorta}</p>
      </div>
    </motion.div>
  );
}
